import React           from 'react';
import { Route, Link } from 'react-router-dom';
import Avatar          from './Avatar';
import { getMe }       from './Login';

function MenuItem (props) {
    if (props.where === props.to){
        return (
            <li className="nav-item active">
                <div className="nav-link">{props.text}</div>
            </li>
        );
    }
    else {
        return (
            <li className="nav-item">
                <Link className="nav-link" to={props.to}>{props.text}</Link>
            </li>
        );
    }
}

export default function Navbar(props) {
    const me = ( props.me !== undefined ) ? props.me : getMe();
    return (
        <nav className="navbar navbar-expand-sm navbar-dark bg-dark">
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav">
                    <Route render={ (p)=> <MenuItem where={p.location.pathname} text="Начало" to="/" /> } />
                    { me.is_admin && 
                        <Route render={ (p)=> <MenuItem where={p.location.pathname} text="Новый проект" to="/new_project"  /> } /> }
                    <Route render={ (p)=> <MenuItem where={p.location.pathname} text="Выйти" to="/logout"  /> } />
                </ul>
            </div>
            <li className="navbar-text dropdown">
                <Avatar email={me.email} size='30' />
                <span className='ml-2'><Link to={'/user/'+me.id} className='text-white-50'>{me.name}</Link></span>
            </li>
        </nav>
    );
}
